import { GetServerSideProps } from 'next';
import { getIntlProps } from '@moxy/next-intl';
import { CategoriesPage } from '../../../src/containers/pages/questions/CategoriesPage';
import { Category } from '../../../src/containers/pages/questions/categories/types';
import { fetchCategories } from '../../../src/containers/pages/questions/categories/fetchCategories';
import { config } from '../../../src/config/config';
// eslint-disable-next-line import/no-default-export
export default CategoriesPage;

export const getServerSideProps: GetServerSideProps<{
  categories: Category[];
}> = async (ctx) => {
  ctx.res.setHeader('Cache-Control', 'public, s-maxage=10, stale-while-revalidate=59');
  const languageParam = ctx.locale ?? 'en';
  try {
    const categories = await fetchCategories(languageParam);
    return {
      props: {
        categories,
        ...(await getIntlProps(ctx.locale))
      }
    };
  } catch (e) {
    console.error(e);
    return {
      props: {
        categories: [],
        ...(await getIntlProps(ctx.locale))
      },
      redirect: {
        destination: config.domain,
        permanent: true
      }
    };
  }
};
